export default "__VITE_ASSET__DosvC3$l__"